hideTargetForm = (selector) => {
  selector.find('input').prop('checked', false)
  selector.hide()
}

$(document).on('change', '.target-type-selector', (e) =>{
  target_type = $(e.currentTarget).find('option:selected').val()
  
  switch (target_type) {
  case 'nothing':
    hideTargetForm($('#week-days-form'))
    break
  case 'week_day':
    $('#week-days-form').show()
    break
  }
})
